// Forwarder. Routes existing call sites through @crewmates/api-client-legacy.
// Path strings preserved verbatim from the previous implementation — no route
// normalization in this step. Imports in pages/components continue to work unchanged.

import { apiClient } from '../_lib/apiClient';

export const submitContactQuery = async (data) => {
  return apiClient.post('/contactus/add', data, { auth: 'basic' });
};

export const getFaqList = async () => {
  return apiClient.get('/faq', null, { auth: 'basic' });
};

export const report = async (data) => {
  const fd = new FormData();
  fd.append('message', data.message);
  fd.append('bookingId', data.bookingId);
  if (data.photos && data.photos.length) {
    data.photos.forEach((file) => {
      fd.append('files', file.current);
    });
  }
  return apiClient.post('/report', fd, { auth: 'bearer' });
};

export const getFaqCategory = async () => {
  return apiClient.get('/category/list', null, { auth: 'basic' });
};

export async function siteSettings() {
  return apiClient.get('/site-settings', null, { auth: 'basic' });
}
